import { MDSDropdown } from '@marqvision/mds-v2';
import { useAssetOptions } from '~/components/Filters/@hooks';
import { ResponsiveProps } from '~/components/Responsive/@types';

export const AssetFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const assets = useAssetOptions();

  return (
    <MDSDropdown
      label="Assets"
      value={assets.selected}
      list={assets.list}
      isDisabled={assets.disabled}
      isLoading={assets.isFetching}
      onChange={(value) => assets.select(value)}
      modules={[
        'search',
        {
          type: 'filter-button',
          size,
        },
      ]}
    />
  );
};
